"use client";
import { useState, useEffect } from "react";
import RangeSlider from "react-range-slider-input";
import "react-range-slider-input/dist/style.css";
import styles from "./generator.module.scss";
import { useSearchParams, useRouter } from "next/navigation";

export default function PriceRange() {
  const searchParams = useSearchParams();
  const priceMin = searchParams.get("priceMin") || "0";
  const priceMax = searchParams.get("priceMax") || "5000";

  const [price, setPrice] = useState<[number, number]>([
    parseInt(priceMin),
    priceMax === "Infinity" ? 5000 : parseInt(priceMax),
  ]);

  useEffect(() => {
    setPrice([
      parseInt(priceMin),
      priceMax === "Infinity" ? 5000 : parseInt(priceMax),
    ]);
  }, [priceMin, priceMax]);

  const handlePriceChange = (val) => {
    setPrice(val);
  };

  const router = useRouter();

  const handleThumbDragEnd = () => {
    const params = new URLSearchParams(searchParams);
    params.set("priceMin", price[0].toString());
    params.set("priceMax", price[1] >= 5000 ? "Infinity" : price[1].toString());
    router.push(`?${params.toString()}`, { scroll: false });
  };

  return (
    <div className={styles.rangePriceSlider}>
      <p className={styles.priceLabel}>
        {price[0]} kr - {price[1] === 5000 ? "5000 kr >" : `${price[1]} kr`}
      </p>
      <RangeSlider
        min={0}
        max={5000}
        value={price}
        defaultValue={price}
        onInput={handlePriceChange}
        onThumbDragEnd={handleThumbDragEnd}
        className={styles.presentSlider}
        ariaLabel={["Minimum price", "Maximum price"]}
      />
    </div>
  );
}
